// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-product-page-tsx": () => import("./../../../src/components/ProductPage.tsx" /* webpackChunkName: "component---src-components-product-page-tsx" */),
  "component---src-pages-cart-tsx": () => import("./../../../src/pages/cart.tsx" /* webpackChunkName: "component---src-pages-cart-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-test-js": () => import("./../../../src/pages/test.js" /* webpackChunkName: "component---src-pages-test-js" */),
  "component---src-templates-products-catalog-tsx": () => import("./../../../src/templates/productsCatalog.tsx" /* webpackChunkName: "component---src-templates-products-catalog-tsx" */)
}

